import { bindActionCreators } from "redux";
import { call, put, take, takeLatest } from "redux-saga/effects";

import * as apiCaller from "../api/apiCaller";

export const GET_DASHBOARD_INBOUND = "GET_DASHBOARD_INBOUND";
export const GET_DASHBOARD_INBOUND_ERROR = "GET_DASHBOARD_INBOUND_ERROR";
export const GET_DASHBOARD_INBOUND_SUCCESS = "GET_DASHBOARD_INBOUND_SUCCESS";

export const GET_DASHBOARD_OUTBOUND = "GET_DASHBOARD_OUTBOUND";
export const GET_DASHBOARD_OUTBOUND_ERROR = "GET_DASHBOARD_OUTBOUND_ERROR";
export const GET_DASHBOARD_OUTBOUND_SUCCESS = "GET_DASHBOARD_OUTBOUND_SUCCESS";

export const GET_DASHBOARD_CONTACT_CENTER = "GET_DASHBOARD_CONTACT_CENTER";
export const GET_DASHBOARD_CONTACT_CENTER_ERROR =
  "GET_DASHBOARD_CONTACT_CENTER_ERROR";
export const GET_DASHBOARD_CONTACT_CENTER_SUCCESS =
  "GET_DASHBOARD_CONTACT_CENTER_SUCCESS";

export const GET_DASHBOARD_CONTRACT = "GET_DASHBOARD_CONTRACT";
export const GET_DASHBOARD_CONTRACT_ERROR = "GET_DASHBOARD_CONTRACT_ERROR";
export const GET_DASHBOARD_CONTRACT_SUCCESS = "GET_DASHBOARD_CONTRACT_SUCCESS";

export const GET_LIST_SOURCE_PAGE = "GET_LIST_SOURCE_PAGE";
export const GET_LIST_SOURCE_PAGE_ERROR = "GET_LIST_SOURCE_PAGE_ERROR";
export const GET_LIST_SOURCE_PAGE_SUCCESS = "GET_LIST_SOURCE_PAGE_SUCCESS";

export const GET_AGENT_CHAT_REPORT = "GET_AGENT_CHAT_REPORT";
export const GET_AGENT_CHAT_REPORT_ERROR = "GET_AGENT_CHAT_REPORT_ERROR";
export const GET_AGENT_CHAT_REPORT_SUCCESS = "GET_AGENT_CHAT_REPORT_SUCCESS";
/**
 * Reducer
 */

const initialState = {
  inbound: [],
  error: false,
  loading: false,
  outbound: [],
  contact: [],
  listSourcePage: [],
};

export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_DASHBOARD_INBOUND:
      return {
        ...state,
        loading: true,
      };
    case GET_DASHBOARD_INBOUND_SUCCESS:
      return {
        ...state,
        loading: false,
        inbound: action.payload,
      };
    case GET_DASHBOARD_INBOUND_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get outbound
    case GET_DASHBOARD_OUTBOUND:
      return {
        ...state,
        loading: true,
      };
    case GET_DASHBOARD_OUTBOUND_SUCCESS:
      return {
        ...state,
        loading: false,
        outbound: action.payload,
      };
    case GET_DASHBOARD_OUTBOUND_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get list
    case GET_DASHBOARD_CONTACT_CENTER:
      return {
        ...state,
        loading: true,
      };

    case GET_DASHBOARD_CONTACT_CENTER_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.payload,
      };

    case GET_DASHBOARD_CONTACT_CENTER_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    case GET_DASHBOARD_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contracts: action.payload,
      };

    case GET_DASHBOARD_CONTRACT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case GET_LIST_SOURCE_PAGE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_SOURCE_PAGE_SUCCESS:
      return {
        ...state,
        listSourcePage: action.payload,
        loading: false,
      };
    case GET_LIST_SOURCE_PAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case GET_AGENT_CHAT_REPORT_SUCCESS:
      return {
        ...state,
        agentChatReport: action.payload,
        loading: false,
      };
    case GET_AGENT_CHAT_REPORT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};

/**
 * Action
 */

export const dashboardContact = (where) => ({
  type: GET_DASHBOARD_CONTACT_CENTER,
  data: {
    where,
  },
});

export const dashboardContract = (where) => ({
  type: GET_DASHBOARD_CONTRACT,
  data: {
    where,
  },
});

export const dashboardInbound = (from, to, number, groupId, contactCode) => ({
  type: GET_DASHBOARD_INBOUND,
  data: {
    from,
    to,
    number,
    groupId,
    contactCode,
  },
});

export const dashboardOutbound = (from, to, number, groupId, contactCode) => ({
  type: GET_DASHBOARD_OUTBOUND,
  data: {
    from,
    to,
    number,
    groupId,
    contactCode,
  },
});

export const getListSourcePage = () => ({
  type: GET_LIST_SOURCE_PAGE,
  data: {},
});

export const getAgentChatReport = (params) => ({
  type: GET_AGENT_CHAT_REPORT,
  data: params,
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      dashboardInbound,
      dashboardOutbound,
      dashboardContact,
      getListSourcePage,
      getAgentChatReport,
      dashboardContract,
    },
    dispatch
  );
};

/**
 * Apis
 */

const dashboardContactApi = (where) => {
  return apiCaller.getData(`/vnpost/contact-center`, { filter: { where } });
};

const dashboardContractApi = (where) => {
  return apiCaller.getData(`/vnpost/contract`, { filter: { where } });
};

const dashboardInboundApi = (from, to, number, groupId, contactCode) => {
  return apiCaller.getData(`/cloud-pbx/inbound-call/report-hours`, {
    from,
    to,
    number,
    groupId,
    contactCode,
  });
};

const dashboardOutboundApi = (from, to, number, groupId, contactCode) => {
  return apiCaller.getData(`/cloud-pbx/outbound-call/report-by-hours`, {
    from,
    to,
    number,
    groupId,
    contactCode,
  });
};

const getListSourcePageApi = () => {
  return apiCaller.getData(`/omni-channel/channel`);
};

const getAgentChatReportApi = (params) => {
  return apiCaller.getData(`/call-center/agent/department-report`, params);
};

/**
 * sagas
 */

export const dashboardContactFlow = function* () {
  while (true) {
    const action = yield take(GET_DASHBOARD_CONTACT_CENTER);
    try {
      const res = yield call(dashboardContactApi, action.data.where);
      yield put({
        type: GET_DASHBOARD_CONTACT_CENTER_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      yield put({ type: GET_DASHBOARD_CONTACT_CENTER_ERROR, error });
    }
  }
};

export const dashboardContractFlow = function* () {
  while (true) {
    const action = yield take(GET_DASHBOARD_CONTRACT);
    try {
      const res = yield call(dashboardContractApi, action.data.where);
      yield put({ type: GET_DASHBOARD_CONTRACT_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_DASHBOARD_CONTRACT_ERROR, error });
    }
  }
};

export const dashboardInboundFlow = function* () {
  while (true) {
    const action = yield take(GET_DASHBOARD_INBOUND);
    try {
      const res = yield call(
        dashboardInboundApi,
        action.data.from,
        action.data.to,
        action.data.number,
        action.data.groupId,
        action.data.contactCode
      );
      const inboundCalls = res?.data?.inboundCalls || [];
      const inboundCallHours = res?.data?.inboundCallHours || [];

      inboundCalls.sort(function (a, b) {
        var n = new Date(a.date).getTime() - new Date(b.date).getTime();
        if (n !== 0) {
          return n;
        }
        return a.hour - b.hour;
      });

      inboundCalls.forEach((item) => {
        // item.date = item.date ? item.date : 'Tổng'
        item.hour = item.hour !== undefined ? `${item.hour}h` : "Tổng";
        item.asr = item.asr ? `${item.asr.toFixed(2)}%` : "0%";
        item.msr = item.msr ? `${item.msr.toFixed(2)}%` : "0%";
      });
      inboundCallHours.forEach((item) => {
        // item.date = item.date ? item.date : 'Tổng'
        item.hourNumber = Number(item.hour || 0);
        item.hour = item.hour !== undefined ? `${item.hour}h` : "Tổng";
        item.asr = item.asr ? `${item.asr.toFixed(2)}%` : "0%";
        item.msr = item.msr ? `${item.msr.toFixed(2)}%` : "0%";
      });

      let data = [
        ["Thời gian", "Đã trả lời", "Nhỡ", "Từ chối", "Tỷ lệ trả lời(%)"],
      ];
      const showHour = [
        7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      ];

      showHour.map((h) => {
        const val = inboundCallHours.find((item) => item.hourNumber == h) || {};
        if (val.hour === 24) {
          val.hour = 0;
        }
        const totalCalls =
          (val.rejectedCalls || 0) +
          (val.answeredCalls || 0) +
          (val.missedCalls || 0);
        const answeredRate =
          Math.round(((val.answeredCalls || 0) / totalCalls) * 100) || 0;

        data.push([
          `${h}h`,
          val.answeredCalls || 0,
          val.missedCalls || 0,
          val.rejectedCalls || 0,
          answeredRate || 0,
        ]);
      });

      let _data = [
        [
          "Thời gian",
          "Số lượng cuộc gọi",
          { role: "annotation" },
          "Số điện thoại viên",
          { role: "annotation" },
          "Cuộc gọi nhỡ",
          { role: "annotation" },
          "Tỉ lệ trả lời",
        ],
      ];
      inboundCallHours.map((val) => {
        if (val.hour === 24) {
          val.hour = 0;
        }
        _data.push([
          val.hour,
          val.calls,
          val.calls,
          val.agentCount !== undefined ? val.agentCount : 0,
          val.agentCount,
          val.missedCalls,
          val.missedCalls,
          val.asr ? (val.calls * parseFloat(val.asr)) / 100 : 0,
        ]);
      });

      inboundCalls["reportChart"] = data;
      inboundCalls["reportInbound"] = _data;

      if (inboundCalls[inboundCalls.length - 1]) {
        inboundCalls.unshift(inboundCalls.pop());
      }
      yield put({ type: GET_DASHBOARD_INBOUND_SUCCESS, payload: inboundCalls });
    } catch (error) {
      yield put({ type: GET_DASHBOARD_INBOUND_ERROR, error });
    }
  }
};

export const dashboardOutboundFlow = function* () {
  while (true) {
    const action = yield take(GET_DASHBOARD_OUTBOUND);
    try {
      const res = yield call(
        dashboardOutboundApi,
        action.data.from,
        action.data.to,
        action.data.number,
        action.data.groupId,
        action.data.contactCode
      );

      const outboundCalls = res?.data?.outboundCalls || [];
      const outboundCallHours = res?.data?.outboundCallHours || [];

      outboundCalls.sort(function (a, b) {
        var n = new Date(a.date).getTime() - new Date(b.date).getTime();
        if (n !== 0) {
          return n;
        }
        return a.hour - b.hour;
      });
      outboundCalls.forEach((item) => {
        item.hour = item.hour !== undefined ? `${item.hour}h` : "";
        item.asr = item.asr ? `${item.asr.toFixed(2)}%` : "";
      });
      outboundCallHours.forEach((item) => {
        item.hour = item.hour !== undefined ? `${item.hour}h` : "";
        item.asr = item.asr ? `${item.asr.toFixed(2)}%` : "";
      });

      let data = [["Thời gian", "Số lượng cuộc gọi", "Số điện thoại viên"]];
      outboundCallHours.map((val) => {
        if (val.hour === 24) {
          val.hour = 0;
        }
        data.push([
          val.hour,
          val.calls,
          val.agentCount !== undefined ? val.agentCount : 0,
        ]);
      });

      let _data = [
        [
          "Thời gian",
          "Tổng số cuộc",
          { role: "annotation" },
          "Số cuộc trả lời",
          { role: "annotation" },
          "Số cuộc không trả lời",
          { role: "annotation" },
          "Số cuộc bận",
          { role: "annotation" },
          "Số điện thoại viên",
          { role: "annotation" },
          "Tỉ lệ nghe máy",
        ],
      ];
      outboundCallHours.map((val) => {
        if (val.hour === 24) {
          val.hour = 0;
        }
        _data.push([
          val.hour,
          val.calls,
          val.calls,
          val.answeredCalls,
          val.answeredCalls,
          val.noAnsweredCalls,
          val.noAnsweredCalls,
          val.busyCalls,
          val.busyCalls,
          val.agentCount !== undefined ? val.agentCount : 0,
          val.agentCount,
          val.asr ? (val.calls * parseFloat(val.asr)) / 100 : 0,
        ]);
      });

      outboundCalls["reportChart"] = data;
      outboundCalls["reportOutbound"] = _data;
      if (outboundCalls[outboundCalls.length - 1]) {
        outboundCalls.unshift(outboundCalls.pop());
      }
      yield put({
        type: GET_DASHBOARD_OUTBOUND_SUCCESS,
        payload: outboundCalls,
      });
    } catch (error) {
      yield put({ type: GET_DASHBOARD_OUTBOUND_ERROR, error });
    }
  }
};

export const getListSourcePageFlow = function* () {
  while (true) {
    yield take(GET_LIST_SOURCE_PAGE);
    try {
      const res = yield call(getListSourcePageApi);
      yield put({ type: GET_LIST_SOURCE_PAGE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_SOURCE_PAGE_ERROR, error });
    }
  }
};

export const fetchAgentChatReportFlow = function* (action) {
  try {
    if (action.data?.idDepartment?.length > 0) {
      const res = yield call(getAgentChatReportApi, action.data);
      yield put({ type: GET_AGENT_CHAT_REPORT_SUCCESS, payload: res.data });
    }
  } catch (error) {
    yield put({ type: GET_AGENT_CHAT_REPORT_ERROR, error });
  }
};

export const getAgentChatReportFlow = function* () {
  yield takeLatest(GET_AGENT_CHAT_REPORT, fetchAgentChatReportFlow);
};
